import { AxiosAdapter, AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { ApiLog, Transaction } from "./types";
import { buildPreviewXlsx } from "./previewXlsx";

/** Общие строки для обеих выгрузок предпросмотра. */
const EXPORT_ROWS = [
  [
    "id",
    "merchant_order_id",
    "amount_start",
    "amount_paid",
    "currency",
    "status",
    "transaction_type",
    "created_at",
  ],
  [
    "tx_preview_001",
    "ORD-4471",
    "15000",
    "15000",
    "rub",
    "completed",
    "deposit",
    "12.08.2026 10:14:02",
  ],
  [
    "tx_preview_002",
    "ORD-4472",
    "8200",
    "0",
    "rub",
    "canceled",
    "deposit",
    "12.08.2026 10:41:55",
  ],
];

const buildPreviewExport = (format: "csv" | "xlsx"): Blob => {
  if (format === "xlsx") {
    return buildPreviewXlsx(EXPORT_ROWS, "Transactions");
  }
  return new Blob([EXPORT_ROWS.map((row) => row.join(",")).join("\n") + "\n"], {
    type: "text/csv",
  });
};

const previewUser = {
  id: 9001,
  username: "preview.support",
  role: "support",
};

const merchants = [
  { id: 1, name: "Aurora Market", terminals: [] },
  { id: 2, name: "North Star", terminals: [] },
  { id: 3, name: "Pixel Store", terminals: [] },
];

const providers = [
  { id: 11, name: "Atlas Pay" },
  { id: 12, name: "Nova Processing" },
  { id: 13, name: "Orbit Finance" },
];

const rates = {
  1: [
    {
      operation_type: "deposit",
      payment_method: "rub_fps",
      currency: "rub",
      rate: 8.2,
      minsum: 10_000,
      maxsum: 15_000,
    },
    {
      operation_type: "deposit",
      payment_method: "rub_card_number",
      currency: "rub",
      rate: 8.6,
      minsum: 10_000,
      maxsum: 15_000,
    },
    {
      operation_type: "deposit",
      payment_method: "rub_fps",
      currency: "rub",
      rate: 7.6,
      minsum: 15_000,
      maxsum: 50_000,
    },
    {
      operation_type: "deposit",
      payment_method: "rub_card_number",
      currency: "rub",
      rate: 8,
      minsum: 15_000,
      maxsum: 50_000,
    },
    {
      operation_type: "deposit",
      payment_method: "rub_card_number",
      currency: "rub",
      rate: 7.1,
      minsum: 50_000,
      maxsum: 100_000,
    },
    {
      operation_type: "payout",
      payment_method: "rub_card_number",
      currency: "rub",
      rate: 5.9,
      minsum: 10_000,
      maxsum: 15_000,
    },
    {
      operation_type: "payout",
      payment_method: "rub_card_number",
      currency: "rub",
      rate: 5.4,
      minsum: 15_000,
      maxsum: 50_000,
    },
    {
      operation_type: "payout",
      payment_method: "rub_fps",
      currency: "rub",
      rate: 4.9,
      minsum: 50_000,
      maxsum: 100_000,
    },
    {
      operation_type: "payout",
      payment_method: "rub_card_number",
      currency: "rub",
      rate: 5,
      minsum: 50_000,
      maxsum: 100_000,
    },
    {
      operation_type: "cashin",
      payment_method: "rub_card_number",
      currency: "rub",
      rate: 6.8,
      minsum: 10_000,
      maxsum: 15_000,
    },
    {
      operation_type: "cashin",
      payment_method: "rub_fps",
      currency: "rub",
      rate: 6.3,
      minsum: 15_000,
      maxsum: 50_000,
    },
    {
      operation_type: "cashin",
      payment_method: "rub_card_number",
      currency: "rub",
      rate: 6.5,
      minsum: 15_000,
      maxsum: 50_000,
    },
    {
      operation_type: "cashin",
      payment_method: "rub_fps",
      currency: "rub",
      rate: 5.8,
      minsum: 50_000,
      maxsum: 100_000,
    },
    {
      operation_type: "cashin",
      payment_method: "rub_card_number",
      currency: "rub",
      rate: 6,
      minsum: 50_000,
      maxsum: 100_000,
    },
    {
      operation_type: "withdrawal",
      payment_method: "rub_fps",
      currency: "rub",
      rate: 5.1,
      minsum: 10_000,
      maxsum: 15_000,
    },
    {
      operation_type: "withdrawal",
      payment_method: "rub_card_number",
      currency: "rub",
      rate: 5.3,
      minsum: 10_000,
      maxsum: 15_000,
    },
    {
      operation_type: "withdrawal",
      payment_method: "rub_card_number",
      currency: "rub",
      rate: 4.7,
      minsum: 15_000,
      maxsum: 50_000,
    },
    {
      operation_type: "withdrawal",
      payment_method: "rub_card_number",
      currency: "rub",
      rate: 4.3,
      minsum: 50_000,
      maxsum: 100_000,
    },
  ],
  2: [
    {
      operation_type: "deposit",
      payment_method: "rub_card_number",
      currency: "rub",
      rate: 8.1,
      minsum: 500,
      maxsum: 200_000,
    },
    {
      operation_type: "cashin",
      payment_method: "rub_fps",
      currency: "rub",
      rate: 6.4,
      minsum: 1_500,
      maxsum: 120_000,
    },
  ],
  3: [
    {
      operation_type: "withdrawal",
      payment_method: "rub_card_number",
      currency: "rub",
      rate: 4.8,
      minsum: 3_000,
      maxsum: 90_000,
    },
  ],
};

const providerRates = {
  11: [
    {
      id: 501,
      provider_terminal_id: 501,
      operation_type: "deposit",
      payment_method: "rub_fps",
      currency: "rub",
      rate: 4.2,
      minsum: 1_000,
      maxsum: 180_000,
    },
    {
      id: 502,
      provider_terminal_id: 502,
      operation_type: "payout",
      payment_method: "rub_card_number",
      currency: "rub",
      rate: 3.8,
      minsum: 2_000,
      maxsum: 120_000,
    },
  ],
  12: [
    {
      id: 503,
      provider_terminal_id: 503,
      operation_type: "deposit",
      payment_method: "rub_card_number",
      currency: "rub",
      rate: 4.6,
      minsum: 500,
      maxsum: 200_000,
    },
  ],
  13: [
    {
      id: 504,
      provider_terminal_id: 504,
      operation_type: "cashin",
      payment_method: "rub_fps",
      currency: "rub",
      rate: 3.9,
      minsum: 1_500,
      maxsum: 100_000,
    },
  ],
};

/**
 * Каскады провайдеров.
 *
 * Терминалы разложены плоским списком с собственными id — так их отдаёт бэкенд
 * (`provider_terminal_id` = id объекта ProviderPaymentTerminal). Сохранённые
 * каскады держим в памяти, чтобы страницу можно было протыкать без бэкенда:
 * сохранил, перезагрузил — увидел результат.
 */
const providerTerminals = [
  { id: 101, provider_id: 11, operation_type: "deposit", payment_method: "rub_fps", currency: "rub", rate: 4.2, minsum: 1_000, maxsum: 180_000 },
  { id: 102, provider_id: 11, operation_type: "deposit", payment_method: "rub_card_number", currency: "rub", rate: 4.4, minsum: 1_000, maxsum: 200_000 },
  { id: 103, provider_id: 11, operation_type: "payout", payment_method: "rub_card_number", currency: "rub", rate: 3.8, minsum: 2_000, maxsum: 120_000 },
  { id: 104, provider_id: 12, operation_type: "deposit", payment_method: "rub_card_number", currency: "rub", rate: 4.6, minsum: 500, maxsum: 200_000 },
  { id: 105, provider_id: 12, operation_type: "deposit", payment_method: "rub_fps", currency: "rub", rate: 4.9, minsum: 5_000, maxsum: 150_000 },
  { id: 106, provider_id: 13, operation_type: "deposit", payment_method: "rub_fps", currency: "rub", rate: 3.9, minsum: 1_500, maxsum: 100_000 },
  { id: 107, provider_id: 13, operation_type: "payout", payment_method: "rub_card_number", currency: "rub", rate: 4.1, minsum: 1_000, maxsum: 90_000 },
];

const providerNameById = new Map(providers.map((p) => [p.id, p.name]));

const rateKeyOf = (k: Record<string, any>) =>
  [
    k.merchant_id,
    k.payment_method,
    k.operation_type,
    k.currency,
    Number(k.minsum),
    Number(k.maxsum),
  ].join("|");

/** cascade key -> [{ provider_terminal_id, priority, enabled }] */
const savedCascades = new Map<
  string,
  { provider_terminal_id: number; priority: number; enabled: boolean }[]
>();

savedCascades.set(rateKeyOf({ merchant_id: 1, payment_method: "rub_fps", operation_type: "deposit", currency: "rub", minsum: 10_000, maxsum: 15_000 }), [
  { provider_terminal_id: 101, priority: 1, enabled: true },
  { provider_terminal_id: 106, priority: 2, enabled: false },
]);

const serializeTerminal = (t: (typeof providerTerminals)[number]) => ({
  ...t,
  provider_terminal_id: t.id,
  provider_name: providerNameById.get(t.provider_id) ?? "unknown",
});

/** Тот же отбор, что и на бэкенде: метод, операция, валюта и пересечение диапазонов. */
const eligibleTerminals = (rate: Record<string, any>) =>
  providerTerminals
    .filter(
      (t) =>
        t.payment_method === rate.payment_method &&
        t.operation_type === rate.operation_type &&
        t.currency === rate.currency &&
        t.maxsum > Number(rate.minsum) &&
        t.minsum < Number(rate.maxsum),
    )
    .map(serializeTerminal);

const findRate = (
  merchantId: number,
  predicate: (r: any) => boolean,
): any | null => {
  const list = (rates as Record<string, any[]>)[String(merchantId)] || [];
  return list.find(predicate) ?? null;
};

const cascadeResponse = (merchantId: number, rate: any) => {
  const full = { merchant_id: merchantId, ...rate };
  const stored = savedCascades.get(rateKeyOf(full)) ?? [];
  const byId = new Map(providerTerminals.map((t) => [t.id, t]));

  return {
    merchant_rate: full,
    eligible_provider_terminals: eligibleTerminals(full),
    cascade: stored
      .slice()
      .sort((a, b) => a.priority - b.priority)
      .map((item, index) => {
        const terminal = byId.get(item.provider_terminal_id);
        if (!terminal) return null;
        return {
          ...serializeTerminal(terminal),
          cascade_item_id: 1000 + index,
          priority: item.priority,
          enabled: item.enabled,
        };
      })
      .filter(Boolean),
  };
};

const statuses: Transaction["status"][] = [
  "completed",
  "created",
  "dispute",
  "canceled",
];

const transactions: Transaction[] = Array.from({ length: 34 }, (_, index) => {
  const createdAt = new Date(Date.now() - index * 37 * 60 * 1000);
  const status = statuses[index % statuses.length];
  const amount = 3_500 + index * 875;

  return {
    merchant_order_id: `MERCH-${String(12000 + index)}`,
    user_id: `user-${String(430 + index)}`,
    fullname: ["Анна Смирнова", "Иван Петров", "Мария Орлова"][index % 3],
    mid_warn: null,
    id: `fz-preview-${String(index + 1).padStart(4, "0")}`,
    number: `2200 •••• •••• ${String(4100 + index)}`,
    status,
    mid_order_id: `PROV-${String(8400 + index)}`,
    bank_name: ["Альфа-Банк", "Т-Банк", "Сбербанк"][index % 3],
    our_fee: Math.round(amount * 0.025),
    merch_id: merchants[index % merchants.length].id,
    start_amount: amount,
    mid_fee: Math.round(amount * 0.012),
    payment_terminal_id: providers[index % providers.length].id,
    paid_amount: status === "completed" ? amount : 0,
    created_at: createdAt.toISOString(),
    transaction_type: index % 4 === 0 ? "payout" : "deposit",
    currency: "RUB",
    updated_at:
      status === "created"
        ? null
        : new Date(createdAt.getTime() + 12 * 60 * 1000).toISOString(),
    payment_method: index % 2 === 0 ? "rub_fps" : "rub_card_number",
    exchange_rate: 1,
    our_rate: 7.5,
    user_ip: `10.20.30.${20 + index}`,
    mid_rate: 4.2,
    qr_code: null,
    pago_id: null,
    mid_exchange_rate: 1,
  };
});

const logs: ApiLog[] = Array.from({ length: 12 }, (_, index) => ({
  id: index + 1,
  ts: new Date(Date.now() - index * 11 * 60 * 1000).toISOString(),
  transaction_id: transactions[index].id,
  request_id: `req-preview-${String(index + 1).padStart(3, "0")}`,
  provider: providers[index % providers.length].name,
  method: index % 3 === 0 ? "POST" : "GET",
  url: index % 2 === 0 ? "/transactions/create" : "/callbacks/payin",
  status: index % 5 === 0 ? 422 : 200,
  duration_ms: 86 + index * 47,
  request_headers: { "content-type": "application/json", "x-preview": "true" },
  response_headers: { "content-type": "application/json" },
  request_body: JSON.stringify({ amount: 12_500 + index * 500, currency: "RUB" }),
  response_body: JSON.stringify(
    index % 5 === 0
      ? { detail: "Preview validation example" }
      : { ok: true, transaction_id: transactions[index].id },
  ),
  error: index % 5 === 0 ? "Validation error" : null,
}));

const chartSeries = (base: number, step: number) =>
  Array.from({ length: 48 }, (_, index) =>
    Math.round(base + Math.sin(index / 4) * step + (index % 6) * step * 0.18),
  );

const stats = {
  all_payin: chartSeries(420_000, 95_000),
  all_payin_success: chartSeries(338_000, 72_000),
  payin_given_count: chartSeries(94, 24),
  payin_given: chartSeries(365_000, 82_000),
  all_payin_success_count: chartSeries(78, 18),
  count_payin: chartSeries(116, 28),
  total_payin: 18_750_000,
  provider_payin: 16_830_000,
  provider_payin_percentage: 89.8,
  success_payin: 14_940_000,
  success_payin_percentage: 88.7,
  total_payout: 9_280_000,
  success_payout: 8_710_000,
  avg_payin: 18_640,
  avg_success_payin: 19_420,
  success_payin_count: 769,
  provider_payin_count: 842,
  no_reqs: 96,
  total_payin_count: 938,
  success_by_providers: {
    11: chartSeries(36, 9),
    12: chartSeries(29, 7),
    13: chartSeries(22, 6),
  },
};

const balance = Object.fromEntries(
  merchants.map((merchant, index) => [
    merchant.id,
    {
      deposit: {
        fiat: { rub: 1_280_000 + index * 430_000, kzt: 740_000 + index * 120_000 },
        usdt: 18_500 + index * 2_100,
      },
      payout: {
        fiat: { rub: 620_000 + index * 215_000, kzt: 390_000 + index * 80_000 },
        usdt: 8_200 + index * 1_400,
      },
      frozen: {
        fiat: { rub: 84_000 + index * 21_000, kzt: 48_000 + index * 12_000 },
        usdt: 940 + index * 170,
      },
    },
  ]),
);

const normalizePath = (config: InternalAxiosRequestConfig) =>
  (config.url || "")
    .trim()
    .replace(/^https?:\/\/[^/]+/i, "")
    .replace(/^\/api/, "")
    .replace(/\/+$/, "");

const makeResponse = (
  config: InternalAxiosRequestConfig,
  data: unknown,
): AxiosResponse => ({
  data,
  status: 200,
  statusText: "OK",
  headers: { "x-finzora-preview": "true" },
  config,
  request: { preview: true },
});

/**
 * Второй фактор в preview: состояние живёт в памяти, код принимается любой из
 * шести цифр. Этого хватает, чтобы пройти мастер подключения и посмотреть все
 * состояния секции, не поднимая бэкенд.
 */
const twoFactor = {
  enabled: false,
  pendingSecret: null as string | null,
};

const previewTotpValid = (code: unknown) => /^\d{6}$/.test(String(code ?? ""));

/**
 * Пользователи панели в preview: список живёт в памяти, изменения видны до
 * перезагрузки страницы. Ограничения бэкенда (последний админ, своя роль,
 * владелец мерчанта) воспроизведены — иначе их нельзя посмотреть без бэка.
 */
let previewUsers = [
  {
    id: 1,
    username: "admin",
    role: "admin",
    twofa_enabled: true,
    twofa_locked: false,
    created_at: "2025-03-14T09:12:00Z",
    password_changed_at: "2026-01-20T11:05:00Z",
    merchant_id: null as number | null,
  },
  {
    id: 2,
    username: "support.anna",
    role: "support",
    twofa_enabled: false,
    twofa_locked: false,
    created_at: "2025-07-02T14:40:00Z",
    password_changed_at: null as string | null,
    merchant_id: null as number | null,
  },
  {
    id: 3,
    username: "sunrise.pay",
    role: "merchant",
    twofa_enabled: true,
    twofa_locked: true,
    created_at: "2025-09-19T08:00:00Z",
    password_changed_at: "2025-11-30T16:22:00Z",
    merchant_id: 4 as number | null,
  },
  {
    id: 4,
    username: "ref.partner",
    role: "ref",
    twofa_enabled: false,
    twofa_locked: false,
    created_at: "2026-02-11T10:15:00Z",
    password_changed_at: null as string | null,
    merchant_id: null as number | null,
  },
];

// Добираем список до объёма, на котором видна пагинация: на боевом стенде
// пользователей заметно больше, чем помещается на страницу.
previewUsers = previewUsers.concat(
  Array.from({ length: 18 }, (_, index) => ({
    id: 100 + index,
    username: `merchant.demo${String(index + 1).padStart(2, "0")}`,
    role: "merchant",
    twofa_enabled: index % 3 === 0,
    twofa_locked: false,
    created_at: new Date(Date.UTC(2025, 5, 1 + index, 9, 30)).toISOString(),
    password_changed_at: null as string | null,
    merchant_id: (20 + index) as number | null,
  })),
);

/** Реестр валют: часть из базы, часть работает по умолчанию. */
let previewCurrencies = [
  {
    code: "rub",
    title: "Российский рубль",
    symbol: "₽",
    minor_units: 2,
    api_alias: null as string | null,
    updated_at: null as string | null,
    source: "код",
    methods: ["rub_fps", "rub_card_number"],
  },
  {
    code: "kgs",
    title: "Киргизский сом",
    symbol: "⃀",
    minor_units: 2,
    api_alias: null as string | null,
    updated_at: null as string | null,
    source: "код",
    methods: ["kgs_elqr"],
  },
  {
    code: "bol",
    title: "Боливийский боливиано",
    symbol: "Bs",
    minor_units: 2,
    api_alias: "bob" as string | null,
    updated_at: null as string | null,
    source: "код",
    methods: [],
  },
  {
    code: "bhd",
    title: "Бахрейнский динар",
    symbol: "BHD",
    minor_units: 3,
    api_alias: null as string | null,
    updated_at: "2026-10-07T11:20:00Z" as string | null,
    source: "база",
    methods: [],
  },
];

/** Реестр методов оплаты: часть строк «из базы», часть работает по умолчанию. */
let previewMethods = [
  {
    code: "rub_fps",
    currency: "rub",
    payment_form: true,
    card_form: false,
    page_code: null as string | null,
    phone: { country_code: "7", national_len: 10, local_prefixes: ["8"] },
    bank_aliases: { "т-банк": "Т-Банк", "альфа": "Альфа-Банк" },
    updated_at: "2026-08-20T11:00:00Z" as string | null,
    source: "база",
  },
  {
    code: "rub_card_number",
    currency: "rub",
    payment_form: true,
    card_form: true,
    page_code: null as string | null,
    phone: null as any,
    bank_aliases: {},
    updated_at: null as string | null,
    source: "код",
  },
  {
    code: "kgs_elqr",
    currency: "kgs",
    payment_form: true,
    card_form: false,
    page_code: "kgs_qr",
    phone: null as any,
    bank_aliases: {},
    updated_at: null as string | null,
    source: "код",
  },
  {
    code: "kzt_phone_transfer",
    currency: null as string | null,
    payment_form: false,
    card_form: false,
    page_code: null as string | null,
    phone: { country_code: "7", national_len: 10, local_prefixes: ["8"] },
    bank_aliases: { "каспи": "Kaspi Bank" },
    updated_at: null as string | null,
    source: "код",
  },
];

const PREVIEW_CURRENCIES = ["rub", "kzt", "kgs", "azn", "usdt"];

/** Наборы ключей: значения не отдаются даже в предпросмотре. */
let previewCredentials = [
  {
    id: 12,
    provider_id: 11,
    provider: "Atlas Pay",
    label: "Россия, СБП",
    scope: {
      payment_method: "rub_fps",
      operation_type: "deposit",
      currency: "rub",
      bank_name: null as string | null,
      minsum: null as number | null,
      maxsum: null as number | null,
    },
    fields: ["API_KEY", "MERCHANT_ID", "SECRET_KEY"],
    readable: true,
    priority: 100,
    enabled: true,
    created_at: "2026-08-28T10:00:00Z" as string | null,
    updated_at: null as string | null,
  },
  {
    id: 13,
    provider_id: 12,
    provider: "Nova Processing",
    label: "Казахстан, карты",
    scope: {
      payment_method: null as string | null,
      operation_type: "payout",
      currency: "kzt",
      bank_name: null as string | null,
      minsum: 1000 as number | null,
      maxsum: 500000 as number | null,
    },
    fields: null as string[] | null,
    readable: false,
    priority: 50,
    enabled: true,
    created_at: "2026-07-14T08:30:00Z" as string | null,
    updated_at: "2026-08-02T12:10:00Z" as string | null,
  },
];

/** Схемы полей ключей по провайдерам — ответ /provider_credentials/fields. */
const previewCredentialSchemas = [
  {
    provider_id: 11,
    provider: "Atlas Pay",
    title: "Atlas Pay",
    reads_sets: true,
    note: "Счёт выбирается методом оплаты. В наборе, у которого в области выбран метод, суффикс можно не писать.",
    common_fields: [
      {
        name: "BASE_URL",
        title: "Base URL",
        hint: "Корень API провайдера. Пустое поле — адрес из кода. Лишний или недостающий слэш на конце исправляется сам.",
        required: false,
        secret: false,
        default: "https://api.atlaspay.example",
        env: null as string | null,
      },
    ],
    accounts: [
      {
        code: "main",
        title: "Основной счёт",
        note: null as string | null,
        scope: {
          payment_methods: [] as string[],
          operation_type: null as string | null,
          amount_from: null as number | null,
          amount_to: null as number | null,
        },
        fields: [
          {
            name: "TOKEN",
            title: "Токен",
            hint: "Уходит в заголовке AP-Token.",
            required: true,
            secret: true,
            default: null as string | null,
            env: "ATLAS_TOKEN" as string | null,
          },
          {
            name: "SECRET_KEY",
            title: "Секрет (для подписи)",
            hint: "Секрет HMAC-SHA256, подпись уходит в AP-Signature.",
            required: true,
            secret: true,
            default: null as string | null,
            env: "ATLAS_SECRET" as string | null,
          },
          {
            name: "MERCHANT_ID",
            title: "Идентификатор мерчанта",
            hint: "Уходит полем merchant_id в теле запроса.",
            required: true,
            secret: false,
            default: null as string | null,
            env: "ATLAS_MERCHANT" as string | null,
          },
        ],
        generic_fields: [] as string[],
      },
      {
        code: "bhd",
        title: "Бахрейнский счёт",
        note: "Берётся, когда заказ идёт в бахрейнских динарах.",
        scope: {
          payment_methods: ["bhd_bank_transfer"] as string[],
          operation_type: "deposit" as string | null,
          amount_from: null as number | null,
          amount_to: null as number | null,
        },
        fields: [
          {
            name: "TOKEN_BHD",
            title: "Токен",
            hint: "Уходит в заголовке AP-Token.",
            required: true,
            secret: true,
            default: null as string | null,
            env: "ATLAS_TOKEN_BHD" as string | null,
          },
          {
            name: "SECRET_KEY_BHD",
            title: "Секрет (для подписи)",
            hint: "Секрет HMAC-SHA256, подпись уходит в AP-Signature.",
            required: true,
            secret: true,
            default: null as string | null,
            // Переменной окружения нет — счёт работает только через набор.
            env: null as string | null,
          },
        ],
        generic_fields: ["TOKEN", "SECRET_KEY"] as string[],
      },
    ],
    without_env: ["SECRET_KEY_BHD"] as string[],
  },
  {
    provider_id: 12,
    provider: "Nova Processing",
    title: "Nova Processing",
    reads_sets: true,
    note: "поля этого провайдера пока не описаны: имена вводятся вручную",
    common_fields: [] as any[],
    accounts: [] as any[],
    without_env: [] as string[],
  },
  {
    provider_id: 13,
    provider: "Orbit Finance",
    title: "Orbit Finance",
    reads_sets: false,
    note: "интеграция читает ключи только из окружения — набор можно завести, но он ни на что не повлияет",
    common_fields: [] as any[],
    accounts: [] as any[],
    without_env: [] as string[],
  },
];

const previewPassword = () => `Fz-${Math.random().toString(36).slice(2, 12)}!7`;

const getPreviewData = (config: InternalAxiosRequestConfig) => {
  const path = normalizePath(config);

  if (path === "/currencies") {
    if ((config.method ?? "get").toLowerCase() === "post") {
      const body = config.data ? JSON.parse(config.data) : {};
      if (previewCurrencies.some((c) => c.code === body.code)) {
        return { __status: 409, detail: "Валюта с таким кодом уже существует" };
      }
      const created = {
        code: body.code,
        title: body.title ?? body.code.toUpperCase(),
        // Как на бэкенде: пустой знак превращается в код заглавными —
        // пустое место рядом с суммой хуже, чем «AED».
        symbol: (body.symbol ?? "").trim() || body.code.toUpperCase(),
        minor_units: body.minor_units ?? 2,
        api_alias: body.api_alias ?? null,
        updated_at: new Date().toISOString(),
        source: "база",
        methods: [] as string[],
      };
      previewCurrencies = [...previewCurrencies, created];
      return created;
    }
    return { items: previewCurrencies, note: "предпросмотр" };
  }

  if (path === "/currencies/reload") {
    return {
      loaded: previewCurrencies.length,
      methods_reloaded: previewMethods.length,
      source: "база",
      note: "предпросмотр",
    };
  }

  if (path.startsWith("/currencies/")) {
    const code = path.split("/")[2];
    const index = previewCurrencies.findIndex((c) => c.code === code);
    if (index === -1) return { __status: 400, detail: "Валюта неизвестна" };

    const body = config.data ? JSON.parse(config.data) : {};
    const updated = {
      ...previewCurrencies[index],
      title: body.title ?? null,
      symbol: (body.symbol ?? "").trim() || code.toUpperCase(),
      minor_units: body.minor_units ?? 2,
      api_alias: body.api_alias ?? null,
      updated_at: new Date().toISOString(),
      source: "база",
    };
    previewCurrencies = previewCurrencies.map((c, i) =>
      i === index ? updated : c,
    );
    // Алиас виден мерчанту — бэкенд в этом случае добавляет предупреждение.
    return updated.api_alias
      ? {
          ...updated,
          warning: `валюта уходит мерчанту как '${updated.api_alias}', а не '${code}'`,
        }
      : updated;
  }

  if (path === "/payment_methods") {
    if ((config.method ?? "get").toLowerCase() === "post") {
      const body = config.data ? JSON.parse(config.data) : {};
      if (previewMethods.some((m) => m.code === body.code)) {
        return { __status: 409, detail: "Метод с таким кодом уже есть" };
      }
      const created = { ...body, updated_at: new Date().toISOString(), source: "база" };
      previewMethods = [...previewMethods, created];
      return created;
    }
    return { items: previewMethods, currencies: PREVIEW_CURRENCIES, note: "предпросмотр" };
  }

  if (path === "/payment_methods/reload") {
    return { loaded: previewMethods.length, source: "база", note: "предпросмотр" };
  }

  if (path.startsWith("/payment_methods/")) {
    const code = path.split("/")[2];
    const body = config.data ? JSON.parse(config.data) : {};
    const index = previewMethods.findIndex((m) => m.code === code);
    if (index === -1) return { __status: 400, detail: "Метод неизвестен" };
    // PUT замещает настройки целиком — фикстура ведёт себя так же.
    const updated = { ...body, code, updated_at: new Date().toISOString(), source: "база" };
    previewMethods = previewMethods.map((m, i) => (i === index ? updated : m));
    return updated;
  }

  // Схемы полей: по ним админка строит форму ключей. Три провайдера нарочно
  // показывают три разных случая — описанный, неописанный и тот, что наборы
  // не читает.
  if (path === "/provider_credentials/fields") {
    const q = (config.params ?? {}) as Record<string, any>;
    const items = q.provider_id
      ? previewCredentialSchemas.filter(
          (item) => item.provider_id === Number(q.provider_id),
        )
      : previewCredentialSchemas;
    return {
      items,
      note: "набор применяется целиком: поля одного счёта заводятся вместе",
    };
  }

  if (path === "/provider_credentials") {
    if ((config.method ?? "get").toLowerCase() === "post") {
      const body = config.data ? JSON.parse(config.data) : {};
      const created = {
        id: Math.max(0, ...previewCredentials.map((c) => c.id)) + 1,
        provider_id: body.provider_id,
        provider: providers.find((p) => p.id === body.provider_id)?.name ?? "—",
        label: body.label,
        scope: body.scope ?? {},
        fields: Object.keys(body.payload ?? {}).sort(),
        readable: true,
        priority: body.priority ?? 100,
        enabled: body.enabled !== false,
        created_at: new Date().toISOString(),
        updated_at: null,
      };
      previewCredentials = [...previewCredentials, created as any];
      return created;
    }
    const q = (config.params ?? {}) as Record<string, any>;
    const items = q.provider_id
      ? previewCredentials.filter((c) => c.provider_id === Number(q.provider_id))
      : previewCredentials;
    return { items, note: "значения ключей не отдаются" };
  }

  if (path.startsWith("/provider_credentials/")) {
    const id = Number(path.split("/")[2]);
    const index = previewCredentials.findIndex((c) => c.id === id);
    if (index === -1) return { __status: 404, detail: "Набор не найден" };

    if ((config.method ?? "get").toLowerCase() === "delete") {
      previewCredentials = previewCredentials.filter((c) => c.id !== id);
      return {};
    }

    const body = config.data ? JSON.parse(config.data) : {};
    const current = previewCredentials[index];
    const updated = {
      ...current,
      ...(body.label !== undefined ? { label: body.label } : {}),
      ...(body.scope !== undefined ? { scope: body.scope } : {}),
      ...(body.priority !== undefined ? { priority: body.priority } : {}),
      ...(body.enabled !== undefined ? { enabled: body.enabled } : {}),
      ...(body.payload
        ? { fields: Object.keys(body.payload).sort(), readable: true }
        : {}),
      updated_at: new Date().toISOString(),
    };
    previewCredentials = previewCredentials.map((c, i) =>
      i === index ? (updated as any) : c,
    );
    return updated;
  }

  if (path === "/auth/roles") {
    return { roles: ["admin", "merchant", "ref", "support"] };
  }

  // Выгрузка: отдаём настоящий Blob, иначе страница посчитает ответ пустым.
  // Формат уважается по-настоящему: csv отдаётся текстом, xlsx собирается в
  // валидную книгу. Csv под именем .xlsx Excel открывать отказывается.
  if (path === "/transactions/export/csv" || path === "/transactions/export") {
    const body = config.data ? JSON.parse(config.data) : {};
    return buildPreviewExport(body.format === "xlsx" ? "xlsx" : "csv");
  }

  if (path === "/auth/users") {
    if ((config.method ?? "get").toLowerCase() === "post") {
      const body = config.data ? JSON.parse(config.data) : {};
      const username = String(body.username ?? "").trim();
      if (previewUsers.some((u) => u.username === username)) {
        return { __status: 409, detail: "User already exists" };
      }
      const created = {
        id: Math.max(...previewUsers.map((u) => u.id)) + 1,
        username,
        role: String(body.role ?? "support"),
        twofa_enabled: false,
        twofa_locked: false,
        created_at: new Date().toISOString(),
        password_changed_at: null as string | null,
        merchant_id: null as number | null,
      };
      previewUsers = [...previewUsers, created];
      const generated = !body.password;
      return {
        id: created.id,
        username: created.username,
        role: created.role,
        generated_password: generated,
        password: generated ? previewPassword() : null,
      };
    }

    const q = (config.params ?? {}) as Record<string, any>;
    return previewUsers.filter(
      (user) =>
        (!q.role || user.role === q.role) &&
        (!q.search ||
          user.username.toLowerCase().includes(String(q.search).toLowerCase())),
    );
  }

  if (path.startsWith("/auth/users/") && !path.includes("/2fa/")) {
    const id = Number(path.split("/")[3]);
    const user = previewUsers.find((u) => u.id === id);
    if (!user) return { __status: 404, detail: "User not found" };

    const method = (config.method ?? "get").toLowerCase();

    if (path.endsWith("/password/reset")) {
      previewUsers = previewUsers.map((u) =>
        u.id === id ? { ...u, password_changed_at: new Date().toISOString() } : u,
      );
      return {
        id: user.id,
        username: user.username,
        generated_password: true,
        password: previewPassword(),
        sessions_revoked: true,
      };
    }

    if (method === "patch") {
      const body = config.data ? JSON.parse(config.data) : {};
      if (body.role && body.role !== user.role) {
        if (user.merchant_id !== null) {
          return {
            __status: 409,
            detail: {
              message: "User owns a merchant, role must stay 'merchant'",
              merchant_id: user.merchant_id,
            },
          };
        }
        const otherAdmins = previewUsers.filter(
          (u) => u.role === "admin" && u.id !== id,
        ).length;
        if (user.role === "admin" && !otherAdmins) {
          return {
            __status: 409,
            detail: "This is the last admin, role cannot be changed",
          };
        }
      }
      const updated = {
        ...user,
        username: body.username ?? user.username,
        role: body.role ?? user.role,
      };
      previewUsers = previewUsers.map((u) => (u.id === id ? updated : u));
      return updated;
    }

    if (method === "delete") {
      if (user.merchant_id !== null) {
        return {
          __status: 409,
          detail: {
            message: "User owns a merchant and cannot be deleted",
            merchant_id: user.merchant_id,
          },
        };
      }
      previewUsers = previewUsers.filter((u) => u.id !== id);
      return {};
    }

    return user;
  }

  if (path.startsWith("/auth/2fa") || path.includes("/2fa/reset")) {
    const body = config.data ? JSON.parse(config.data) : {};

    if (path === "/auth/2fa/status") {
      return {
        enabled: twoFactor.enabled,
        pending_setup: Boolean(twoFactor.pendingSecret) && !twoFactor.enabled,
      };
    }

    if (path === "/auth/2fa/setup") {
      twoFactor.pendingSecret = "JBSWY3DPEHPK3PXPPREVIEWDEMO2FA00";
      return {
        secret: twoFactor.pendingSecret,
        otpauth_url: `otpauth://totp/Finzora:preview.support?secret=${twoFactor.pendingSecret}&issuer=Finzora&algorithm=SHA1&digits=6&period=30`,
        issuer: "Finzora",
      };
    }

    if (path === "/auth/2fa/enable") {
      if (!previewTotpValid(body.code)) {
        return { __status: 400, detail: "Invalid code" };
      }
      twoFactor.enabled = true;
      return { enabled: true };
    }

    if (path === "/auth/2fa/disable") {
      if (!previewTotpValid(body.code)) {
        return { __status: 400, detail: "Invalid code" };
      }
      twoFactor.enabled = false;
      twoFactor.pendingSecret = null;
      return { enabled: false };
    }

    if (path.includes("/2fa/reset")) {
      return { status: "success" };
    }
  }

  if (path.startsWith("/provider_cascades")) {
    const q = (config.params ?? {}) as Record<string, any>;
    const body = config.data ? JSON.parse(config.data) : {};

    if (path === "/provider_cascades/rate" && (config.method ?? "get") === "get") {
      const rate = findRate(
        Number(q.merchant_id),
        (r) =>
          r.payment_method === q.payment_method &&
          r.operation_type === q.operation_type &&
          r.currency === q.currency &&
          Number(r.minsum) === Number(q.minsum) &&
          Number(r.maxsum) === Number(q.maxsum),
      );
      if (!rate) return { detail: "MerchantPaymentRate not found" };
      return cascadeResponse(Number(q.merchant_id), rate);
    }

    if (path === "/provider_cascades/rate/by_amount") {
      const amount = Number(q.amount);
      const rate = findRate(
        Number(q.merchant_id),
        (r) =>
          r.payment_method === q.payment_method &&
          r.operation_type === q.operation_type &&
          amount >= Number(r.minsum) &&
          amount < Number(r.maxsum),
      );
      if (!rate) return { detail: "MerchantPaymentRate not found" };
      return cascadeResponse(Number(q.merchant_id), rate);
    }

    if (
      path === "/provider_cascades/rate" &&
      (config.method ?? "").toLowerCase() === "delete"
    ) {
      const key = rateKeyOf(body);
      const removed = savedCascades.get(key)?.length ?? 0;
      savedCascades.delete(key);
      return { status: "success", deleted_items: removed };
    }

    if (path === "/provider_cascades/rate") {
      // PUT: полная замена. priority может не прийти — берём порядок массива.
      const items = (body.items ?? []).map((item: any, index: number) => ({
        provider_terminal_id: item.provider_terminal_id ?? item.terminal_id,
        priority: item.priority ?? index + 1,
        enabled: item.enabled !== false,
      }));
      savedCascades.set(rateKeyOf(body), items);
      return { status: "success", items_count: items.length };
    }

    if (path === "/provider_cascades/rate/item") {
      const key = rateKeyOf(body);
      const items = savedCascades.get(key) ?? [];
      const target = items.find(
        (i) => i.provider_terminal_id === body.provider_terminal_id,
      );
      if (target) target.enabled = body.enabled;
      savedCascades.set(key, items);
      return {
        status: "success",
        cascade_item_id: 1000 + items.indexOf(target as any),
        enabled: body.enabled,
      };
    }

    if (path === "/provider_cascades/rate/reorder") {
      const key = rateKeyOf(body);
      const items = savedCascades.get(key) ?? [];
      const ordered = (body.provider_terminal_ids as number[]).map((id, index) => {
        const existing = items.find((i) => i.provider_terminal_id === id);
        return {
          provider_terminal_id: id,
          priority: index + 1,
          enabled: existing ? existing.enabled : true,
        };
      });
      savedCascades.set(key, ordered);
      return { status: "success", provider_terminal_ids: body.provider_terminal_ids };
    }
  }

  if (path === "/auth/login") {
    // Логин отражает состояние второго фактора: если он включён в этой сессии
    // preview, форма покажет второй шаг — как и на живом бэкенде.
    return twoFactor.enabled
      ? { details: "two-factor code required", twofa_required: true }
      : { details: "login successful", twofa_required: false, user: previewUser };
  }
  if (path === "/auth/login/2fa") {
    const body = config.data ? JSON.parse(config.data) : {};
    if (!previewTotpValid(body.code)) {
      return { __status: 401, detail: "Invalid code" };
    }
    return { details: "login successful", user: previewUser };
  }
  if (path === "/me") {
    return { user: previewUser };
  }
  if (path === "/transactions/payin-stats") return stats;
  if (path === "/merchants/create") {
    return {
      merchant: { id: 12, name: "Preview Merchant", fiat: true },
      user: {
        id: 4400,
        username: "preview.merchant",
        role: "merchant",
        generated_password: true,
        password: "Preview-2026!",
      },
      // Форма выдачи доступов показывает ключ, поэтому фикстура обязана его вернуть.
      api_key: "fz_live_9f3c1d7a4b2e48c6ae05d31f7b6c9a20",
    };
  }
  if (path === "/merchants") return merchants;
  if (path === "/transactions/available_methods") {
    return {
      payment_methods: {
        "RUB FPS": "rub_fps",
        "RUB Card": "rub_card_number",
      },
      currencies: { rub: "rub", kzt: "kzt", usdt: "usdt" },
    };
  }
  // PATCH /provider_rates/terminal/{id} — правка существующей ставки.
  if (/^\/provider_rates\/terminal\/\d+$/.test(path)) {
    const terminalId = Number(path.split("/").pop());
    const body = config.data ? JSON.parse(config.data) : {};
    for (const list of Object.values(providerRates) as any[]) {
      const target = list.find((t: any) => t.id === terminalId);
      if (target) {
        Object.assign(target, body);
        return target;
      }
    }
    return { __status: 404, detail: "ProviderPaymentTerminal not found" };
  }

  if (path === "/rates") return rates;
  if (path === "/providers") return providers;
  if (path === "/provider_rates") return providerRates;
  if (path === "/balance" || path === "/referral_balance") return balance;
  if (path === "/transactions/get_stats") return transactions;
  if (
    path === "/transactions/get_list" ||
    path === "/transactions/get_list_test"
  ) {
    return {
      items: transactions,
      total_count: transactions.length,
      total_pages: 2,
    };
  }
  if (path.startsWith("/panel/logs/by_")) {
    return { events: logs };
  }
  if (path.startsWith("/panel/logs/")) {
    return { items: logs, total_pages: 1 };
  }
  if (path === "/transactions/export/csv") {
    return [
      "id,status,amount,currency",
      ...transactions.slice(0, 8).map((transaction) =>
        [
          transaction.id,
          transaction.status,
          transaction.start_amount,
          transaction.currency,
        ].join(","),
      ),
    ].join("\n");
  }

  return { ok: true, preview: true };
};

export const previewAdapter: AxiosAdapter = async (config) => {
  await new Promise((resolve) => window.setTimeout(resolve, 180));
  const data = getPreviewData(config) as any;

  // Фикстура может попросить вернуть ошибку — иначе в preview не проверить,
  // как страница показывает неверный код или блокировку.
  if (data && typeof data === "object" && "__status" in data) {
    const { __status: status, ...rest } = data;
    const error: any = new Error(`Request failed with status code ${status}`);
    error.isAxiosError = true;
    error.config = config;
    error.response = {
      data: rest,
      status,
      statusText: "Error",
      headers: { "x-finzora-preview": "true" },
      config,
    };
    throw error;
  }

  return makeResponse(config, data);
};
